import moment from 'moment';

export const generateImageInfo = (type, driverData) => {
  if (!driverData) return [];
  console.log('driverData', driverData);
  switch (type) {
    case 'license-front':
    case 'license-back':
      return [
        {
          title: 'Personal Information'
        },
        {
          label: 'First Name',
          value: driverData.firstName
        },
        {
          label: 'Last Name',
          value: driverData.lastName
        },
        {
          label: 'Address',
          value: driverData.address
        },
        {
          label: 'City',
          value: driverData.city
        },
        {
          label: 'State',
          value: driverData.state
        },
        {
          label: 'Zip Code',
          value: driverData.zipCode
        },
        {
          title: 'Driver License'
        },
        {
          label: 'License Number',
          value: driverData.orginalDriverLicenseNumber || driverData.driverLicenseNumber
        },
        {
          label: 'Date of Birth',
          value: driverData.driverLicenseBirthday
            ? moment(driverData.driverLicenseBirthday).format('MM/DD/YYYY')
            : null
        },
        {
          label: 'Expiry Date',
          value: driverData.driverLicenseDateExp
            ? moment(driverData.driverLicenseDateExp).format('MM/DD/YYYY')
            : null
        },
        {
          label: 'State',
          value: driverData.driverLicenseState
        }
      ];

    case 'insurance':
      return [
        {
          title: 'Personal Information'
        },
        {
          label: 'First Name',
          value: driverData.firstName
        },
        {
          label: 'Last Name',
          value: driverData.lastName
        },
        {
          label: 'Address',
          value: driverData.address
        },
        {
          label: 'City',
          value: driverData.city
        },
        {
          label: 'State',
          value: driverData.state
        },
        {
          label: 'Zip Code',
          value: driverData.zipCode
        },
        {
          title: 'Vehicle Information'
        },
        {
          label: 'Vehicle Type',
          value: driverData?.vehicle?.type?.name ?? ''
        },
        {
          label: 'Vehicle Year',
          value: driverData?.vehicle?.year ?? ''
        },
        {
          label: 'Vehicle Brand',
          value: driverData?.vehicle?.brand ?? ''
        },
        {
          label: 'Vehicle Model',
          value: driverData?.vehicle?.model ?? ''
        },
        {
          title: 'Insurance Policy'
        },
        {
          label: 'Policy Number',
          value: driverData.insurancePolicyNumber
        },
        {
          label: 'Expiry Date',
          value: driverData.insuranceDateExp
            ? moment(driverData.insuranceDateExp).format('MM/DD/YYYY')
            : null
        },
        {
          label: 'State',
          value: driverData.insuranceState
        }
      ];

    case 'oai-insurance':
      return [
        {
          title: 'OAI Insurance'
        },
        {
          label: 'Policy Number',
          value: driverData.OAI?.policy_no
        },
        {
          label: 'Expiry Date',
          value: driverData.OAI?.exp_date
            ? moment(driverData.OAI.exp_date).format('MM/DD/YYYY')
            : null
        },
        {
          label: 'Insurance Type',
          value: 'OAI (Occupational Accident Insurance)'
        },
        {
          label: 'Own Insurance',
          value: driverData.OAI?.isOwnOAI ? 'Yes' : 'No'
        }
      ];

    case 'profile':
      return [
        {
          title: 'Personal Information'
        },
        {
          label: 'Driver Name',
          value: `${driverData.firstName || ''} ${driverData.lastName || ''}`.trim()
        },
        {
          label: 'Username',
          value: driverData.username
        },
        {
          label: 'Phone',
          value: driverData.phone
        },
        {
          label: 'Address',
          value: driverData.address
        },
        {
          label: 'City, State',
          value: `${driverData.city || ''}, ${driverData.state || ''}`.replace(', ,', ',').trim()
        },
        {
          label: 'Zip Code',
          value: driverData.zipCode
        }
      ];

    default:
      return [
        {
          title: 'Document Information'
        },
        {
          label: 'Document Type',
          value: type.charAt(0).toUpperCase() + type.slice(1)
        },
        {
          label: 'Upload Date',
          value: moment().format('MM/DD/YYYY')
        }
      ];
  }
};

export const getImageTitle = (type) => {
  const titles = {
    'license-front': 'Driver License - Front',
    'license-back': 'Driver License - Back',
    'insurance': 'Insurance Policy',
    'oai-insurance': 'OAI Insurance Policy',
    'profile': 'Profile Photo'
  };

  return titles[type] || 'Document Preview';
};
